// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2pbGa","modalFooterButton":"ModalNotes_modalFooterButton__GNRO5"};